import {PUSH_ALERT, POP_ALERT, POP_ALL_ALERTS} from 'ondemand/actions/alert';

export default function alerts(state = {
  items: [],
}, action) {
  switch (action.type) {
    case PUSH_ALERT:
      return Object.assign({}, state, {
        items: [...state.items, {
          level: action.level,
          title: action.title,
          subtitle: action.subtitle,
          target: action.target,
          icon: action.icon,
          closeIcon: action.closeIcon,
          hideClose: action.hideClose,
          onClick: action.onClick,
          onClose: action.onClose,
        }],
      });
    case POP_ALERT:
      return Object.assign({}, state, {
        items: state.items.slice(0, state.items.length - 1),
      });
    case POP_ALL_ALERTS:
      return Object.assign({}, state, {items: []});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/alert.js